/**
 * Interactive Product Card 2511 - JavaScript
 * 完整的变体选择、库存管理和加购功能
 */
(function () {
  "use strict";

  class InteractiveProductCard {
    constructor(form) {
      this.form = form;
      this.container = form.querySelector(".product-card-content");
      this.productId = this.container.dataset.productId;
      this.productHandle = this.container.dataset.productHandle;
      this.getFormattedMoney = window.getFormattedMoney;
      // Variant picker elements
      this.variantPicker = form.querySelector(".variant-picker-simple-2511");
      this.variantIdInput = form.querySelector("[data-variant-id-input]");

      // Option elements
      this.colorSwatches = form.querySelectorAll(".button-color-swatch");
      this.sizeUnknownBtn = form.querySelector(".size-btn-unknown");
      this.sizeKnowBtn = form.querySelector(".size-btn-know");
      this.sizeOptions = form.querySelector(".size-options");
      this.sizeOptionBtns = form.querySelectorAll(".size-option-btn");

      // Display elements
      this.productImage = form.querySelector("[data-product-image-wrapper] img");
      this.priceWrapper = form.querySelector("[data-price-wrapper]");
      this.currentPriceEl = form.querySelector("[data-current-price]");
      this.originalProductPriceEl = form.querySelector(".original-product-price");
      this.specialProductPriceEl = form.querySelector(".special-product-price");
      this.discountBadge = form.querySelector("[data-discount-badge]");
      this.discountValue = form.querySelector("[data-discount-value]");
      this.stockStatus = form.querySelector("[data-stock-status]");
      this.sizeBtnText = form.querySelector(".size-btn-text");

      // Action buttons
      this.addToCartBtn = form.querySelector("[data-add-to-cart]");
      this.learnMoreBtn = form.querySelector(".btn-learn-more");
      this.closeIcon = form.querySelector(".size-options-header");

      // Variant data
      this.variants = this.loadVariantData();
      this.currentVariant = null;

      // Selected options
      this.selectedOptions = {};

      this.init();
    }

    init() {
      if (!this.variants || this.variants.length === 0) {
        console.warn("No variant data found for product:", this.productId);
        return;
      }

      this.initializeDefaultSelections();
      this.bindEvents();
      this.updateDisplay();
    }

    loadVariantData() {
      const dataScript = this.form.querySelector("[data-variant-data]");
      if (!dataScript) return [];

      try {
        const data = JSON.parse(dataScript.textContent);
        return data.variants || [];
      } catch (e) {
        console.error("Error parsing variant data:", e);
        return [];
      }
    }

    initializeDefaultSelections() {
      // 初始化颜色选择（第一个颜色）
      if (this.colorSwatches.length > 0) {
        const firstColor = this.colorSwatches[0];
        firstColor.classList.add("active");
        this.selectedOptions["1"] = firstColor.dataset.optionValue;
      }

      // 初始化尺寸选择（默认为 "I don't know my size"）
      if (this.sizeUnknownBtn) {
        this.selectedOptions["2"] = this.sizeOptionBtns[this.sizeOptionBtns.length - 1].dataset.optionValue;
      }

      this.findCurrentVariant();
    }

    bindEvents() {
      // 颜色选择
      this.colorSwatches.forEach((swatch) => {
        swatch.addEventListener("click", (e) => this.handleColorSelection(e));
      });

      // 尺寸选择按钮
      if (this.sizeUnknownBtn) {
        this.sizeUnknownBtn.addEventListener("click", () => this.handleSizeUnknown());
      }

      if (this.sizeKnowBtn) {
        this.sizeKnowBtn.addEventListener("click", () => this.toggleSizeOptions());
      }

      // 具体尺寸选项按钮
      this.sizeOptionBtns.forEach((btn) => {
        if (!btn.disabled) {
          btn.addEventListener("click", (e) => this.handleSizeSelection(e));
        }
      });

      // 表单提交（加购）
      // this.form.addEventListener("submit", (e) => this.handleAddToCart(e));

      // Learn More 按钮
      if (this.learnMoreBtn) {
        this.learnMoreBtn.addEventListener("click", () => this.handleLearnMore());
      }
      if (this.closeIcon) {
        this.closeIcon.addEventListener("click", () => this.handleCloseIcon());
      }
    }
    handleCloseIcon() {
      this.closeSizeOptions();
    }
    closeSizeOptions() {
      this.sizeOptions.style.display = "none";
      this.sizeOptions.classList.remove("show");
    }
    handleColorSelection(e) {
      const swatch = e.currentTarget;
      const color = swatch.dataset.optionValue;
      const position = swatch.dataset.optionPosition;

      // 更新UI
      this.colorSwatches.forEach((s) => s.classList.remove("active"));
      swatch.classList.add("active");

      // 更新选择
      this.selectedOptions[position] = color;

      // 更新隐藏输入
      const input = this.form.querySelector(`[data-option-input="${position}"]`);
      if (input) {
        input.value = color;
      }

      // 更新尺寸选项的可用性
      this.updateSizeAvailability();

      // 查找并更新当前变体
      this.findCurrentVariant();
      this.updateDisplay();
    }

    handleSizeUnknown() {
      // 设置为 "I don't know my size"
      this.sizeUnknownBtn.classList.add("active");
      this.sizeKnowBtn.classList.remove("active", "expanded");

      // 隐藏尺寸选项
      if (this.sizeOptions) {
        this.sizeOptions.style.display = "none";
        this.sizeOptions.classList.remove("show");
      }

      // 清除尺寸按钮选择
      this.sizeOptionBtns.forEach((btn) => btn.classList.remove("active"));

      // 更新选择
      this.selectedOptions["2"] = this.sizeOptionBtns[this.sizeOptionBtns.length - 1].dataset.optionValue;
      // 更新隐藏输入
      const input = this.form.querySelector('[data-option-input="2"]');
      if (input) {
        input.value = this.sizeUnknownBtn.dataset.placeholder;
        this.sizeBtnText.textContent = this.sizeBtnText.dataset.placeholder;
      }

      // 查找并更新当前变体
      this.findCurrentVariant();
      this.updateDisplay();
    }

    toggleSizeOptions() {
      const isExpanded = this.sizeKnowBtn.classList.contains("expanded");

      if (isExpanded) {
        // 收起
        this.sizeKnowBtn.classList.remove("expanded");
        if (this.sizeOptions) {
          this.sizeOptions.style.display = "none";
          this.sizeOptions.classList.remove("show");
        }

        // 如果没有选择具体尺寸，回到 "I don't know my size"
        const hasSelectedSize = Array.from(this.sizeOptionBtns).some((btn) => btn.classList.contains("active"));
        if (!hasSelectedSize) {
          this.handleSizeUnknown();
        }
      } else {
        // 展开
        this.sizeKnowBtn.classList.add("expanded", "active");
        this.sizeUnknownBtn.classList.remove("active");

        if (this.sizeOptions) {
          this.sizeOptions.style.display = "block";
          setTimeout(() => {
            this.sizeOptions.classList.add("show");
          }, 10);
        }
      }
    }

    handleSizeSelection(e) {
      const btn = e.currentTarget;

      if (btn.disabled) return;

      const size = btn.dataset.optionValue;
      const position = btn.dataset.optionPosition;

      // 更新UI
      this.sizeOptionBtns.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      // 保持 "I know my size" 激活和展开
      this.sizeKnowBtn.classList.add("active", "expanded");
      this.sizeUnknownBtn.classList.remove("active");

      // 更新选择
      this.selectedOptions[position] = size;

      // 更新隐藏输入
      const input = this.form.querySelector(`[data-option-input="${position}"]`);
      if (input) {
        input.value = size;
      }
      this.sizeBtnText.textContent = this.sizeBtnText.dataset.clickText.replace("{size}", size);
      this.closeSizeOptions();
      // 查找并更新当前变体
      this.findCurrentVariant();
      this.updateDisplay();
    }

    updateSizeAvailability() {
      if (!this.selectedOptions["1"]) return; // 没有选择颜色

      const selectedColor = this.selectedOptions["1"];

      this.sizeOptionBtns.forEach((btn) => {
        const size = btn.dataset.optionValue;

        // 查找这个颜色+尺寸组合的变体
        const variant = this.variants.find((v) => v.option1 === selectedColor && v.option2 === size);

        if (variant && variant.available) {
          btn.disabled = false;
          btn.classList.remove("disabled");
        } else {
          btn.disabled = true;
          btn.classList.add("disabled");

          // 如果当前选中的尺寸不可用，清除选择
          if (btn.classList.contains("active")) {
            btn.classList.remove("active");
            this.handleSizeUnknown();
          }
        }
      });
    }

    findCurrentVariant() {
      const option1 = this.selectedOptions["1"];
      const option2 = this.selectedOptions["2"];

      this.currentVariant = this.variants.find((v) => {
        const match1 = !option1 || v.option1 === option1;
        const match2 = !option2 || v.option2 === option2;
        return match1 && match2;
      });

      // 如果找到变体，更新隐藏的变体ID输入
      if (this.currentVariant && this.variantIdInput) {
        this.variantIdInput.value = this.currentVariant.id;
      }
      console.log(this.currentVariant, "this.currentVariant");
      return this.currentVariant;
    }

    updateDisplay() {
      if (!this.currentVariant) return;

      // 更新图片
      if (this.currentVariant.featured_image && this.productImage) {
        this.productImage.src = this.currentVariant.featured_image;
        this.productImage.srcset = this.currentVariant.featured_image;
      }

      // 更新价格
      this.updatePrice();

      // 更新库存状态
      this.updateStockStatus();

      // 更新折扣标签
      this.updateDiscountBadge();

      // 更新按钮状态
      this.updateAddToCartButton();
    }

    updatePrice() {
      if (!this.currentVariant) return;

      const price = this.getFormattedMoney(this.currentVariant.price);
      const comparePrice = this.currentVariant.compare_at_price
        ? this.getFormattedMoney(this.currentVariant.compare_at_price)
        : null;

      if (this.currentPriceEl) {
        this.currentPriceEl.textContent = this.getFormattedMoney(this.currentVariant.price);
      }

      this.specialProductPriceEl.classList.remove("price_hidden");
      this.originalProductPriceEl.classList.remove("price_hidden");

      if (
        this.priceWrapper.dataset.specialColor &&
        this.priceWrapper.dataset.specialColor === this.currentVariant.option1
      ) {
        this.originalProductPriceEl.classList.add("price_hidden");
      } else {
        this.specialProductPriceEl.classList.add("price_hidden");
      }
    }

    updateDiscountBadge() {
      if (!this.currentVariant || !this.discountBadge) return;

      if (this.currentVariant.compare_at_price > this.currentVariant.price) {
        const discount = Math.round(
          ((this.currentVariant.compare_at_price - this.currentVariant.price) / this.currentVariant.compare_at_price) *
            100
        );

        if (this.discountValue) {
          this.discountValue.textContent = discount + "%";
        }
        this.discountBadge.style.display = "";
      } else {
        this.discountBadge.style.display = "none";
      }
    }

    updateStockStatus() {
      if (!this.stockStatus) return;

      if (this.currentVariant && !this.currentVariant.available) {
        const stockText = this.stockStatus.querySelector(".stock-text");
        if (stockText) {
          stockText.textContent = 'Sold out';
        }
        this.stockStatus.style.display = "block";
      } else {
        this.stockStatus.style.display = "none";
      }
    }

    updateAddToCartButton() {
      if (!this.addToCartBtn) return;

      const btnText = this.addToCartBtn.querySelector(".btn-text");

      if (this.currentVariant && this.currentVariant.available) {
        this.addToCartBtn.disabled = false;
        this.addToCartBtn.classList.remove("disabled");
        if (btnText) {
          btnText.textContent = this.addToCartBtn.dataset.buttonShowText;
        }
      } else {
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.classList.add("disabled");
        if (btnText) {
          btnText.textContent = this.addToCartBtn.dataset.soldOutText;
        }
      }
    }

    setLoadingState(isLoading) {
      if (!this.addToCartBtn) return;

      const btnText = this.addToCartBtn.querySelector(".btn-text");
      const btnLoading = this.addToCartBtn.querySelector(".btn-loading");

      if (isLoading) {
        this.addToCartBtn.disabled = true;
        if (btnText) btnText.style.display = "none";
        if (btnLoading) btnLoading.style.display = "";
      } else {
        this.addToCartBtn.disabled = false;
        if (btnText) btnText.style.display = "";
        if (btnLoading) btnLoading.style.display = "none";
      }
    }

    triggerCartUpdate() {
      // 触发主题的购物车更新事件
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );

      // 兼容其他可能的购物车事件
      window.dispatchEvent(new CustomEvent("cart:updated"));
    }

    showSuccessMessage() {
      // 你可以自定义成功提示的方式
      // 这里简单使用 alert，实际项目中可以用更好的 toast 提示
      const message = 'Added to your cart!';

      // 如果主题有自己的通知系统，使用主题的通知
      if (window.theme && window.theme.showNotification) {
        window.theme.showNotification(message, "success");
      } else {
        console.log(message);
        // 或者触发一个自定义事件供主题监听
        document.dispatchEvent(
          new CustomEvent("product:added-to-cart", {
            detail: { variant: this.currentVariant },
          })
        );
      }
    }

    showErrorMessage() {
      const message =
        'Translation missing: en.product.general.add_to_cart_error';

      if (window.theme && window.theme.showNotification) {
        window.theme.showNotification(message, "error");
      } else {
        alert(message);
      }
    }

    handleLearnMore() {
      const productUrl = this.learnMoreBtn.dataset.productUrl;
      if (productUrl) {
        window.location.href = productUrl;
      }
    }

    formatMoney(cents) {
      // 简单的价格格式化，你可以根据需要调整
      const money = (cents / 100).toFixed(2);
      return "".replace("", money).replace("", money);
    }
  }

  // 初始化所有产品卡片
  function initInteractiveProductCards() {
    const forms = document.querySelectorAll(".product-form-2511");

    forms.forEach((form) => {
      new InteractiveProductCard(form);
    });
  }

  // Shopify 主题编辑器支持
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      if (event.target.querySelector(".interactive-product-card-section")) {
        initInteractiveProductCards();
      }
    });

    document.addEventListener("shopify:section:reorder", function (event) {
      if (event.target.querySelector(".interactive-product-card-section")) {
        initInteractiveProductCards();
      }
    });
  }

  // 页面加载时初始化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initInteractiveProductCards);
  } else {
    initInteractiveProductCards();
  }
})();
